export default __webpack_public_path__ + "static/media/tag_free-wifi.3c24c00f.svg";